module.exports = __webpack_public_path__ + "static/media/blog1.239d923a.png";